module.exports = __webpack_public_path__ + "img/3_Bericht_Zoll.ac65c77a.svg";